/**
 * Blob をファイルとしてダウンロードする
 *
 * window.URL.createObjectURL で一時 URL を生成し、`<a>` タグの click を dispatch して
 * ブラウザのダウンロードを起動する。ダウンロード後に URL を revoke してメモリを解放する。
 *
 * @param blob - ダウンロード対象の Blob（CSV 等）
 * @param filename - 保存ファイル名。省略時は 'download.csv'
 */
export const downloadFile = (blob: Blob, filename = 'download.csv') => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;

  link.dispatchEvent(
    new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window,
    })
  );

  window.URL.revokeObjectURL(url);
};
